import {
  companyMemberTypes,
  PCR_MEMBER_TYPES,
  TMC_MEMBER_TYPES
} from '@/domain/MyAccount'

export const normalizeMemberTypes = customer =>
  (Array.isArray(customer?.memberTypes) ? customer.memberTypes : [])
    .filter(memberType => typeof memberType === 'string')
    .map(memberType => memberType.trim().toLowerCase())

export const hasMemberType = (customer, memberTypes) => {
  const expectedMemberTypes = Array.isArray(memberTypes) ? memberTypes : [memberTypes]
  const normalizedExpectedTypes = expectedMemberTypes.map(memberType =>
    memberType.toLowerCase()
  )

  return normalizeMemberTypes(customer).some(memberType =>
    normalizedExpectedTypes.includes(memberType)
  )
}

export const hasR4UMemberType = customer => hasMemberType(customer, companyMemberTypes.R4U)

export const hasTMCMemberType = customer =>
  hasMemberType(customer, TMC_MEMBER_TYPES)

export const hasPCRMemberType = customer => hasMemberType(customer, PCR_MEMBER_TYPES)

export const hasLussoMemberType = customer => hasMemberType(customer, companyMemberTypes.LUSSO)

export const hasCorporateMemberType = customer =>
  hasMemberType(customer, companyMemberTypes.CORPORATE)
